<template>
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    stroke-width="2.4"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path :d="down ? 'M12 5v14M6 13l6 6 6-6' : 'M5 12h14M13 6l6 6-6 6'" />
  </svg>
</template>

<script>
// The click-through's button arrow: right by default, down for "take me to".
export default {
  name: 'ArrowIcon',
  props: {
    down: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
